import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, RouterModule } from "@angular/router";

// import { LabelsGroup } from '@core/objects/labels-group';

// import { RulesService } from '@app/services/settings/rules.service';
import { SettingsRulesService } from '@app/services/settings/srules.service';


import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';


@Component({
    selector: 'settings-rules-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsRulesMainComponent implements OnInit, OnDestroy {
    private readonly ACCESS = 'access_setting_rules_access';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    // public availableEvents: Array<AvailableRule>;
    public selectedRule: any = null;
	public access:boolean = true;
    // public status: number = 0;
    public status: number = 0;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        }
    ];

    public menu: Array<ThreeDotsMenuItem> = [{
        title: "Add a new rule",
        key: "add-rule",
        icon: "add",
        order: 1
    }];

    protected sessionSubscriptor: Subscription;

	constructor(public srulesSrv: SettingsRulesService, public app: AppService, private title: TitleService, private router: Router){}

	ngOnInit(){
        this.title.set("Rules - System settings");

        this.sessionSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            this.status = this.STATUS_DONE;
        });

        if (this.access){
            this.srulesSrv.loadAvailableEvents();
            this.srulesSrv.loadRules();
        }


	}

    ngOnDestroy() {
        this.sessionSubscriptor.unsubscribe();
    }

    // onSaved(event){
    //     this.showForm = false;
    //     this.load();
    // }
    // cancel(event){
    //     this.loadEvents();
    // }



    // selectRule(e){
    //     console.debug("set selected ruleevent id",e)
    //     this.selectedRule = e;
    // }

    // selectRuleById(id: Number) {
    //     if(this.selectedRule != null && this.selectedRule.id == id)
    //     {
    //         this.selectedRule = null;
    //         return;
    //     }


    openRule(id: Number){
        this.router.navigate(['/settings/rules/',id]);
    }

    openAddForm() {
        this.selectedRule = null;
        this.router.navigate(['/settings/rules/add']);
        // this.loadEvents();
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-rule":
                this.openAddForm()
                break;
        }
    }

}
